module.exports = "<div class=\"button-round\" [style.marginTop]=\"offset\">\n  <a>\n    <div class=\"icon icon-{{icon}} {{vehicleActive ? 'active' : ''}}\"></div>\n    <p class=\"label\" [innerHTML]=\"sanitized\"></p>\n  </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/button-round/button-round.component.html
// module id = ./src/app/button-round/button-round.component.html
// module chunks = main